/* ================================================================
   SNCKD. — Theme JavaScript (from Claude Design Export)
   Box Slider · Collection Filter · Product Qty · Cart Logic
   ================================================================ */

(() => {
  'use strict';

  /* ─── Box Slider ─── */
  document.querySelectorAll('[data-snckd-slider]').forEach((slider) => {
    const track   = slider.querySelector('.snckd-boxslider__track');
    const prev    = slider.querySelector('[data-action="prev"]');
    const next    = slider.querySelector('[data-action="next"]');
    const count   = slider.querySelector('[data-snckd-slider-count]');
    const dotsBox = slider.querySelector('[data-snckd-slider-dots]');
    if (!track) return;

    const slides = track.querySelectorAll('.snckd-boxslider__slide');
    const total  = slides.length;
    const slideW = () => slides[0] ? slides[0].getBoundingClientRect().width + 20 : 340;

    function indexFromScroll() {
      return Math.round(track.scrollLeft / slideW());
    }
    function update() {
      const i = Math.max(0, Math.min(total - 1, indexFromScroll()));
      if (count) count.innerHTML = `<b>${String(i + 1).padStart(2,'0')}</b> / ${String(total).padStart(2,'0')}`;
      if (dotsBox) dotsBox.querySelectorAll('.snckd-boxslider__dot').forEach((d, di) => {
        d.classList.toggle('is-active', di === i);
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= total - 1;
    }
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -slideW() * 2, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left:  slideW() * 2, behavior: 'smooth' }));

    if (dotsBox) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'snckd-boxslider__dot' + (i === 0 ? ' is-active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Box ${i + 1}`);
        dot.addEventListener('click', () => track.scrollTo({ left: i * slideW(), behavior: 'smooth' }));
        dotsBox.appendChild(dot);
      });
    }
    update();
  });

  /* ─── Collection filter ─── */
  document.querySelectorAll('[data-snckd-filter]').forEach((bar) => {
    const targetSel = bar.dataset.snckdFilter;
    const grid = document.querySelector(targetSel);
    if (!grid) return;
    bar.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        bar.querySelectorAll('button').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const val = btn.dataset.value;
        let shown = 0;
        grid.querySelectorAll('[data-tag]').forEach((card) => {
          const ok = val === 'alle' || card.dataset.tag === val;
          card.style.display = ok ? '' : 'none';
          if (ok) shown++;
        });
        const c = document.querySelector('[data-snckd-count]');
        if (c) c.querySelector('b').textContent = shown;
      });
    });
  });

  /* ─── Ghost parallax ─── */
  const ghosts = document.querySelectorAll('.snckd-ghost');
  if (ghosts.length) {
    let ticking = false;
    const speed = 0.07;
    const update = () => {
      const y = window.scrollY;
      ghosts.forEach((g) => { g.style.transform = `translateX(${y * speed}px)`; });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ─── Product page Qty ─── */
  document.querySelectorAll('[data-snckd-qty]').forEach((qty) => {
    const val = qty.querySelector('[data-qty-val]');
    const dec = qty.querySelector('[data-qty="-1"]');
    const inc = qty.querySelector('[data-qty="+1"]');
    let v = parseInt(val.textContent, 10) || 1;
    const set = (n) => {
      v = Math.max(1, n);
      val.textContent = String(v).padStart(2, '0');
      qty.dispatchEvent(new CustomEvent('change', { detail: v }));
    };
    if (dec) dec.addEventListener('click', () => set(v - 1));
    if (inc) inc.addEventListener('click', () => set(v + 1));
  });

})();
